module.exports = __webpack_public_path__ + "static/2_KING-60e6907e4b633cb312ea942b3879d857.png";